import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcArrowForward20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m16.688 10.688a.886.886 0 0 0 .312-.688c0-.25-.094-.5-.313-.719l-4.968-5a1.044 1.044 0 0 0 -.719-.281c-.563 0-1 .438-1 1 0 .25.094.5.281.688l3.313 3.312h-9.594c-.563 0-1 .438-1 1 0 .531.438 1 1 1h9.594l-3.313 3.281a1.102 1.102 0 0 0 -.281.719c0 .531.438 1 1 1a.95.95 0 0 0 .719-.313l4.969-5z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcArrowForward20;
